import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainSettingListingContainer from './listing/MainSettingListingContainer';

const SettingRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainSettingListingContainer />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default SettingRoutes;
